import { z } from 'zod'
import { CommunicationType, SatLayoutVersion, type PeripheralSatSettings } from '../../models/PeripheralSettings'
import { CommandType } from '../../models/PeripheralManufacturer'

const SatConfigDTO = z.object({
  activation_code: z.string().nullish(),
  layout_version: z.nativeEnum(SatLayoutVersion).nullish(),
  digital_signature: z.string().nullish()
})

export const PeripheralSatSettingsDTO = z.object({
  address: z.string().nullish(),
  port: z.number().nullish(),
  printer_model: z.string().nullish(),
  communication_type: z.nativeEnum(CommunicationType).nullish(),
  command_type: z.nativeEnum(CommandType).nullish(),
  sat: SatConfigDTO.nullish()
})

export type PeripheralSatSettingsDTO = z.infer<typeof PeripheralSatSettingsDTO>

export function mapPeripheralSatSettingsToDTO (model: PeripheralSatSettings): PeripheralSatSettingsDTO {
  return {
    address: model.address,
    port: model.port,
    printer_model: model.model,
    communication_type: model.communicationType,
    command_type: model.commandType,
    sat: model.sat
      ? {
          activation_code: model.sat.activationCode,
          layout_version: model.sat.layoutVersion,
          digital_signature: model.sat.digitalSignature
        }
      : undefined
  }
}

export function mapDTOToPeripheralSatSettings (dto: PeripheralSatSettingsDTO): PeripheralSatSettings {
  return {
    address: dto.address ?? undefined,
    port: dto.port ?? undefined,
    model: dto.printer_model ?? undefined,
    communicationType: dto.communication_type ?? undefined,
    commandType: dto.command_type ?? undefined,
    sat: dto.sat
      ? {
          activationCode: dto.sat.activation_code ?? undefined,
          layoutVersion: dto.sat.layout_version ?? undefined,
          digitalSignature: dto.sat.digital_signature ?? undefined
        }
      : undefined
  }
}
